/**
 * Returns a function that will only be called once every n milliseconds
 *
 * @param fn
 * @param delay
 * @return {function(...[*])}
 */
export const debounce = (fn, delay: number) => {
    if (typeof fn !== 'function') {
        throw new Error('Debounce requires a callback function');
    }

    // biome-ignore lint/suspicious/noGlobalIsNan: This was set before biome was added
    if (isNaN(delay)) {
        throw new Error('Debounce requires a delay');
    }

    // biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
    let timeout: any;

    return (...args) => {
        const later = () => {
            timeout = null;
            return fn(...args);
        };

        clearTimeout(timeout);
        timeout = setTimeout(later, delay);
    };
};
